import type { useGetPartnerAdminsUser } from '~/hooks';
import type { EditUserFormBankAccountPresentation } from '../../presentations';

type PresentationProps = React.ComponentProps<typeof EditUserFormBankAccountPresentation>;

type Args = {
  data: ReturnType<typeof useGetPartnerAdminsUser>['data'];
};

type IConvertToPresentationProps = (
  args: Args
) => Pick<PresentationProps, 'isBillableFromEditable' | 'isInvitee'>;

/**
 * API レスポンスの利用者データを Presentation Props に変換する
 *
 * 【PEN-992 対応】is_invitee が undefined の場合は false 扱いにする。
 *
 * @param args.data - API レスポンスの利用者データ
 * @returns isBillableFromEditable - 利用開始日の編集可否フラグ（Presentation に渡す）
 * @returns isInvitee - 家族招待ユーザーフラグ（Presentation に渡す。schema / generateRequest 用は hooks 内で導出）
 */
export const convertToPresentationProps: IConvertToPresentationProps = ({ data }) => {
  const { user } = data;
  return {
    isBillableFromEditable: user.is_billable_from_editable,
    isInvitee: user.is_invitee ?? false,
  };
};
